import gql from 'graphql-tag'
import { standardOrderItems } from '../fragments'

export default gql`
query CAmaster_getStandardOrderValues($filter: StandardOrderValuesFilter) {
	cashAssist {
		listOrderItems(filter: $filter) {
			items {
				...standardOrderItems
			}
		}
	}
}
${standardOrderItems}`
